module.exports = __webpack_public_path__ + "static/img/a043.6671f93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a043.jpg
// module id = /Deg
// module chunks = 0